import Vue from 'vue'
import Vuex from 'vuex'
import {numeracion_de_documentos, coleccion_movimientos_contables, coleccion_partidas_contables, coleccion_de_libro_diario, customAuth, _firestore}  from '@/FirebaseConfig'
import {secondsToFullTimestamp, obtener_periodo, toNumber, periodo_de_fecha} from '@/Helper.js' 
export default {
    namespaced:true,
    state: {
        movimiento_contable: {
            nombre: '',
            reglas: []
        },
        cuentas: {},
        record: {},
        selectedKey: ''
    },
    mutations: {
        getAllItems(state, item) {
            Vue.set( state.record, item.id, {...item.data(), createdAt: secondsToFullTimestamp(item.data().createdAt)} )
        },
          eliminar(state,key){
            Vue.delete(state.record, key)
        }
    },
    actions: {
        getAll:(context)=>{
            context.state.record = {}
            coleccion_movimientos_contables.onSnapshot(data=>data.docs.map( item => context.commit( 'getAllItems', item  ) ) )
        },
        agregar: async context =>{
            await coleccion_movimientos_contables.add({
                nombre: '',
                reglas: [
                    {
                        nombre_de_regla: '',
                        debe: '',
                        haber: '',
                        porcentaje: 100
                    }
                ],
                fue_creado: new Date()
            }).then(()=>{
                context.commit('Helpers/launchSnackbar', 'Se ha creado un nuevo conjunto de reglas', { root: true })
            })
        },
        eliminar: (context, key) => {
              coleccion_movimientos_contables.doc(key).delete().then(()=>{
              context.commit( 'eliminar', key)
              context.commit('Helpers/launchSnackbar', 'Se ha eliminado el conjunto de reglas', { root: true })
            })
        },
        actualizar:  (context, data) => {
            coleccion_movimientos_contables.doc(data.key).update({
              nombre: data.movimiento.nombre,
              reglas: data.movimiento.reglas,
              actualizado_el: new Date() 
            }).then(()=>context.commit('Helpers/launchSnackbar', 'Se ha actualizado el conjunto de reglas', { root: true }) )
        },
        movimiento_contable:  (context, {valor, regla, proveedor, fecha_caducidad, referencia, llave, fecha, comprobante})=>{
            return new Promise(async (resolve, rejected)=>{
                try {
                    let dato_1 = (proveedor == undefined) ? '' : proveedor
                    let dato_2= (fecha_caducidad== undefined) ? '' : fecha_caducidad
                    let dato_3 = (referencia==undefined) ? 'Carga inicial' : referencia
                    let dato_4 =(fecha) ? secondsToFullTimestamp(fecha) : secondsToFullTimestamp(new Date())
                    let dato_5 = (fecha) ? periodo_de_fecha(fecha) : obtener_periodo()
                    let reglas = await context.dispatch('datos_iniciales', regla)
                    await context.dispatch('regla_independiente', {valor: toNumber(valor), reglas, dato_1, dato_2, dato_3, dato_4, dato_5, llave, comprobante})
                    resolve(true)
                } catch (error) {
                    console.error(error)
                    rejected(error)
                }
            })
        },
        regla_independiente:  (context, {valor_porcentuado, valor, reglas, dato_1, dato_2, dato_3, dato_4, dato_5, llave, comprobante})=>{
            return new Promise(async (resolve, rejected)=>{
                try{
                    let lista_de_acciones = []
                    reglas.map(item=>{
                        let porcentaje = toNumber(Number(item.porcentaje)/100)
                        valor_porcentuado = item.valor_porcentuado || toNumber(valor) * porcentaje 
                        lista_de_acciones.push(context.dispatch('pedido_partida_contable', {codigo: item.debe, valor: valor_porcentuado, tipo: true}))
                        lista_de_acciones.push(context.dispatch('pedido_partida_contable', {codigo: item.haber, valor: valor_porcentuado, tipo: false}))
                    })
                    let partidas_ordenadas= await Promise.all(lista_de_acciones)
                    partidas_ordenadas.map(item=>
                        context.dispatch('operaciones', {...item, proveedor: dato_1, fecha_caducidad: dato_2, referencia: dato_3, creado_el: dato_4, periodo: dato_5, llave, comprobante})
                    )
                    Object.keys(context.state.cuentas).map(item=>context.dispatch('llenado_saldos', context.state.cuentas[item]))
                    context.state.cuentas={}
                    resolve(true)
                } catch (error ){
                    rejected(error)
                }
            })
        },
        pedido_partida_contable:  async (context, {codigo, valor, tipo})=>{
            return new Promise(async (resolve, rejected)=>{
                 try{
                     let partida_contable= await coleccion_partidas_contables.doc(codigo).get()
                     resolve({...partida_contable.data(), valor, tipo})
                 } catch(error){
                     rejected(error)
                     console.log('error', error)
                 }
            })
        },
        operaciones: async (context, objeto)=>{
            try {
                let valor = Number(objeto.valor)    
                let codigo_partida = objeto.codigo
                let tipo = (objeto.tipo) ? 'debe' : 'haber'
                let otro_valor= (objeto.tipo) ? 'haber' : 'debe'
                let proveedor = objeto.proveedor
                let fecha_caducidad = objeto.fecha_caducidad
                let referencia_doc = objeto.referencia
                let fecha = objeto.creado_el
                let periodo = objeto.periodo
                let saldo = objeto.saldo
                let descripcion =  objeto.descripcion
                let debe_o_haber = objeto.tipo
                context.dispatch('llenado_libro_diario', {valor, codigo_partida, tipo, otro_valor, proveedor, fecha_caducidad, referencia_doc, fecha, periodo})
                context.dispatch('actualizando_partida_contable', {valor, codigo_partida, tipo, descripcion, saldo, debe_o_haber, fecha, periodo}) 
            } catch (error) {
               console.error(error)
           }     
        },
        datos_iniciales: async (context, regla)=>{
            try {
                const conjunto_reglas = await coleccion_movimientos_contables.where('nombre', '==', regla).get()
                let reglas = conjunto_reglas.docs[0].data().reglas
                return reglas                
            } catch (error) {
                console.error(error)
            }
        },
        llenado_libro_diario: async (context, objeto)=>{
            try {
                let numeracion = await numeracion_de_documentos.collection('Nota contable').doc('00').get()
                let nueva_numeracion = (!numeracion.exists) ? 1 : numeracion.data().numeracion + 1
                await coleccion_de_libro_diario.add({
                    codigo: objeto.codigo_partida, 
                    [objeto.tipo]: objeto.valor,
                    [objeto.otro_valor]: 0,
                    creado_el: objeto.fecha,
                    periodo: objeto.periodo,
                    creado_por: customAuth.currentUser.displayName,
                    atendido: false,
                    proveedor: objeto.proveedor,
                    fecha_caducidad: objeto.fecha_caducidad,
                    referencia: objeto.referencia_doc,
                    primer_digito: (objeto.codigo_partida.charAt(0)),
                    numeracion: nueva_numeracion
                })
                await numeracion_de_documentos.collection('Nota contable').doc('00').set({numeracion: nueva_numeracion})
                context.commit('Helpers/launchSnackbar', 'Se ha registrado un campo en el libro diario', { root: true })               
            } catch (error) {
                console.error(error)
            }
            
        },
        actualizando_partida_contable: async (context, {valor, codigo_partida, tipo, descripcion, debe_o_haber, saldo, fecha, periodo}) =>{
            try {
                let valor_actual = (debe_o_haber) ? valor : (-1*valor)
                let incremento = _firestore.FieldValue.increment(valor_actual)
                let saldo_valor = (context.state.cuentas[codigo_partida]) ? context.state.cuentas[codigo_partida].valor : 0
                context.state.cuentas[codigo_partida]={
                    codigo_partida,
                    descripcion,
                    saldo,
                    valor: saldo_valor + valor_actual,
                    fecha,
                    periodo_momento: periodo
                }
                coleccion_partidas_contables.doc(codigo_partida).update({[tipo]: incremento})
            } catch (error) {
                console.error(error)
            }
        },
        llenado_saldos: async (context, {codigo_partida, valor, descripcion, saldo, fecha, periodo_momento}) =>{
            try {
                let saldo_viejo=(saldo[periodo_momento]) ? saldo[periodo_momento].saldo : 0
                saldo[periodo_momento]={
                    descripcion,
                    saldo: saldo_viejo+valor, 
                    periodo: periodo_momento
                }
                await coleccion_partidas_contables.doc(codigo_partida).update({'saldo': saldo})        
            } catch (error) {
                console.error(error)
            }
        }
    },
    getters: {
        registro: state => Object.keys(state.record).map(item => ({...state.record[item], key: item })),
    }
}